import React from "react";
import { History } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }) : "—");

export default function OwnerHistory({ code }) {
  const history = [...(code.owner_history || [])].reverse();
  return (
    <div data-testid="owner-history">
      <p className="overline text-[var(--vault-text-muted)] mb-2 inline-flex items-center gap-1.5"><History className="w-3 h-3" /> Ownership history</p>
      {code.owner_email && (
        <p className="text-xs text-[var(--vault-text-muted)] mb-2" data-testid="owner-current-since">
          Current owner since <span className="text-white">{fmt(code.owner_since)}</span>
        </p>
      )}
      {history.length === 0 ? (
        <p className="text-xs text-[var(--vault-text-faint)]" data-testid="owner-history-empty">No previous owners.</p>
      ) : (
        <ol className="space-y-2 max-h-40 overflow-auto pr-1">
          {history.map((h, i) => (
            <li key={`${h.until}-${i}`} className="text-xs rounded-md px-3 py-2" style={{ background: "var(--vault-bg)", border: "1px solid var(--vault-border)" }} data-testid={`owner-history-item-${i}`}>
              <p className="text-white truncate">{h.owner_email || "—"}{h.owner_phone ? <span className="text-[var(--vault-text-faint)] ml-2">{h.owner_phone}</span> : null}</p>
              <p className="text-[var(--vault-text-muted)] font-mono-vault mt-0.5">{fmt(h.since)} → {fmt(h.until)}</p>
              {h.note && <p className="text-[var(--vault-text-faint)] mt-0.5 italic">{h.note}</p>}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
